<table>
  <thead style="overflow-y:scroll;overflow:hidden;width:100%">
    <tr>
      <th style="width:40%">&nbsp;</th>
      <th *ngFor="let day of weekDays;" style="width:95px;text-align: center">{{day.weekDay}}</th>
      <th style="width:70px;text-align:center">Week</th>
      <th style="width:70px;text-align:center">Total</th>
    </tr>
    <tr>
      <th style="width:40%">{{tipus | titlecase}}</th>
      <th *ngFor="let day of weekDays;" style="width:95px">{{day.date}}</th>
      <th style="width:70px;text-align:center">&nbsp;</th>
      <th style="width:70px;text-align:center">&nbsp;</th>
    </tr>
  </thead>
  <tbody style="overflow-y: scroll;width:100%">
    <tr *ngIf="!projectAggregates || !projectAggregates.length">
      <td colspan="10" *ngIf="tipus === 'proposta'">Cap {{tipus}} activa.</td>
      <td colspan="10" *ngIf="tipus !== 'proposta'">Cap {{tipus}} actiu.</td>
    </tr>
    <tr *ngFor="let project of projectAggregates">
      <!-- <td style="font-weight:bold;width:40%;font-size:0.9em;cursor:pointer" md-tooltip="Anar al treball: {{project.titol | uppercase}}" (click)="this.goProject(project.code)">{{project.code}} -->
      <td style="font-weight:bold;width:40%;font-size:0.9em;cursor:pointer" md-tooltip="Anar al treball: {{project.titol | uppercase}}" (click)="this.goProject(project.code)">
       <h3 md-line style="text-align: right">
        <span *ngIf="project.ambit_proposta=='Europa'" style='color:#0000FF'>{{project.code}}</span>
        <span *ngIf="project.ambit_proposta=='Internacional'" style='color:#008800'>{{project.code}}</span>
        <span *ngIf="project.ambit_proposta=='Espanya'" style='color:#800000'>{{project.code}}</span>
        <span *ngIf="project.ambit_proposta=='Catalunya'" style='color:rgb(100,100,100)'>{{project.code}}</span>
       </h3>
      </td>
      <td style="width:95px" *ngFor="let day of weekDays; let i = index;" number (click)="editDay(project, i)">
        {{project.dailyHours[i] | number}}
      </td>
      <td number style="width:70px">
        {{sumWeekHours(project, i) | number}}
      </td>
      <td number style="width:70px">
        {{project.totalHours | number}}
      </td>
    </tr>
    <tr>
      <td style="width:40%"><b>Total</b></td>
      <td  style="width:95px" *ngFor="let hours of weekDaysAcum">{{hours}}</td>
      <td style="width:70px;text-align:center">&nbsp;</td>
      <td style="width:70px;text-align:center">&nbsp;</td>
    </tr>
  </tbody>
  <tfoot>
  </tfoot>
</table>
